import { render } from "./RedirectIcon.vue?vue&type=template&id=4f10e79a"
import script from "./RedirectIcon.vue?vue&type=script&lang=js"
export * from "./RedirectIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__